<script>
  import {
    TableRow,
    Table,
    TableBody,
    TableHeader,
  } from "carbon-components-svelte";
  import Rows from "./Rows.svelte";

  export let headers = [];
  export let rows = [];
  export let dataObject = {};
  export let processInfo = false;
</script>

<Table>
  <TableRow>
    {#each headers as heading}
      <TableHeader class={heading.key === "actions" ? "actions-header" : ""}>
        {heading.value}
      </TableHeader>
    {/each}
  </TableRow>
  <TableBody class="table-body">
    {#each rows as row, i}
      <Rows {processInfo} {row} {dataObject} margin={1} {headers} />
    {/each}
  </TableBody>
</Table>

<style>

</style>
